import { Component, ElementRef, Input, OnInit, ViewChildren } from '@angular/core';
import { MixedObject } from '@app/core/interfaces/mixed-object';
import { Block } from '@app/core/models/block/block.model';
import { GlobalService, MediaQuery } from '@app/core/services/common/global.service';
import { getStyles } from '@app/shared/helpers/block-helpers';
import { MediaUrls } from '@core/interfaces/media.interface';
import { camelCase } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lightbox-preview-video',
  templateUrl: './lightbox-preview-video.component.html',
  styleUrls: ['./lightbox-preview-video.component.scss'],
  standalone: false,
})
export class LightboxPreviewVideoComponent implements OnInit {
  @Input() videoSource: string;
  @Input() urls: MediaUrls;
  @Input() block: Block;
  @Input() photo: Block;
  @ViewChildren('lightboxVideoPlayer', {read: ElementRef}) lightboxVideoPlayer: ElementRef;
  private blockStyles: MixedObject = {};
  private mediaQuerySubscription: Subscription;

  constructor(
    private globalService: GlobalService,
  ) {
    this.mediaQuerySubscription = globalService.mediaQuery.subscribe(mediaQuery => {
      this.generateBlockStyles(mediaQuery);
    });
  }

  get objectFit() {
    const {
      basic: {objectFit},
    } = this.blockStyles;
    return {objectFit};
  }

  get imageStyle() {
    const additionalCss: any = {
      minHeight: '100%',
    };
    const {
      basic: {width, height, minHeight},
    } = this.blockStyles;

    return {
      width,
      height,
      minHeight,
      ...additionalCss,
    };
  }

  ngOnInit() {
    this.generateBlockStyles(this.globalService.mediaQuery.value);
  }

  playVideo() {
    if (this.lightboxVideoPlayer.nativeElement) {
      const video = this.lightboxVideoPlayer.nativeElement.querySelector('video');
      if (video) {
        video.play();
      }
    }
  }

  private generateBlockStyles(mediaQuery: MediaQuery): void {
    const querySnakeCase = camelCase(mediaQuery.query);
    this.blockStyles = getStyles(this.photo?.styles || {}, querySnakeCase);
  }
}
